import { useEffect, useCallback, useState } from 'react'
import './WorldMap.scss'
import * as echarts from 'echarts'
import worldJson from '@surbowl/world-geo-json-zh/world.zh.json'

const WorldMap = () => {
    const [echartsRootDom, setEchartsRootDom] = useState()
    const acquisitionChartRef = useCallback(node => setEchartsRootDom(node), [])

    useEffect(() => {
        if (!echartsRootDom) return
        echarts.registerMap('world', worldJson)
        let myChart = echarts.init(echartsRootDom)

        var geoCoordMap = {
            Zhuozhou: [115.9, 39.4],
            'Saudi Aramco S89': [49.62, 28.35],
            'Saudi Aramco S91': [50.13, 26.94],
            'Saudi Aramco S93': [48.84, 28.21],
            'Qatar NOC 4D': [52.04, 26.62],
            'UAE ADNOC TZ': [53.39, 24.19],
        }
        var BJData = [
            [
                {
                    name: 'Saudi Aramco S89',
                },
                {
                    name: 'Zhuozhou',
                },
            ],
            [
                {
                    name: 'Saudi Aramco S91',
                },
                {
                    name: 'Zhuozhou',
                },
            ],
            [
                {
                    name: 'Saudi Aramco S93',
                },
                {
                    name: 'Zhuozhou',
                },
            ],
            [
                {
                    name: 'Qatar NOC 4D',
                },
                {
                    name: 'Zhuozhou',
                },
            ],
            [
                {
                    name: 'UAE ADNOC TZ',
                },
                {
                    name: 'Zhuozhou',
                },
            ],
        ]
        // var convertData = function (data) {
        //     var res = []
        //     for (var i = 0; i < data.length; i++) {
        //         var dataItem = data[i]
        //         var fromCoord = geoCoordMap[dataItem[0].name] // 起点
        //         var toCoord = geoCoordMap[dataItem[1].name] // 终点
        //         if (fromCoord && toCoord) {
        //             res.push([
        //                 {
        //                     coord: fromCoord,
        //                     value: 2000,
        //                 },
        //                 {
        //                     coord: toCoord,
        //                     value: 6000,
        //                 },
        //             ])
        //         }
        //     }
        //     return res
        // }

        var series = []

        ;[['Zhuozhou', BJData]].forEach(function (item, i) {
            series.push(
                // {
                //     type: 'lines',
                //     zlevel: 2,
                //     effect: {
                //         show: true,
                //         period: 4, //箭头指向速度，值越小速度越快
                //         trailLength: 0.02, //特效尾迹长度[0,1]值越大，尾迹越长重
                //         symbol: 'arrow', //箭头图标
                //         symbolSize: 3, //图标大小
                //     },
                //     lineStyle: {
                //         normal: {
                //             width: 0.5, //尾迹线条宽度
                //             opacity: 0.5, //尾迹线条透明度
                //             curveness: 0.3, //尾迹线条曲直度
                //         },
                //     },
                //     data: convertData(item[1]),
                // },
                {
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    zlevel: 2,
                    rippleEffect: {
                        color: '#ffffff',
                        number: 5,
                        //涟漪特效
                        period: 4, //动画时间，值越小速度越快
                        brushType: 'stroke', //波纹绘制方式 stroke, fill
                        scale: 6, //波纹圆环最大限制，值越大波纹越大
                    },
                    // label: {
                    //     normal: {
                    //         show: true,
                    //         position: 'right', //显示位置
                    //         offset: [5, 0], //偏移设置
                    //         formatter: '{b}', //圆环显示文字
                    //     },
                    //     emphasis: {
                    //         show: true,
                    //     },
                    // },
                    symbol: 'circle',
                    symbolSize: function (val) {
                        return 12 + val[2] / 2000 //圆环大小
                    },
                    itemStyle: {
                        color: '#ffffff',
                        normal: {
                            show: false,
                        },
                    },
                    data: item[1].map(function (dataItem) {
                        return {
                            name: dataItem[0].name,
                            value: geoCoordMap[dataItem[0].name].concat(1000),
                        }
                    }),
                },
                //被攻击点
                {
                    type: 'effectScatter',
                    coordinateSystem: 'geo',
                    zlevel: 2,
                    rippleEffect: {
                        color: '#ffffff',
                        number: 5,
                        //涟漪特效
                        period: 4, //动画时间，值越小速度越快
                        brushType: 'stroke', //波纹绘制方式 stroke, fill
                        scale: 6, //波纹圆环最大限制，值越大波纹越大
                    },
                    // label: {
                    //     normal: {
                    //         show: true,
                    //         position: 'right', //显示位置
                    //         offset: [-40, -36], //偏移设置
                    //         formatter: '{b}', //圆环显示文字
                    //     },
                    //     emphasis: {
                    //         show: true,
                    //     },
                    // },
                    symbol: 'circle',
                    symbolSize: function (val) {
                        return 12 + val[2] / 2000 //圆环大小
                    },
                    itemStyle: {
                        color: '#ffffff',
                        normal: {
                            show: false,
                        },
                    },
                    data: [
                        {
                            name: item[0],
                            value: geoCoordMap[item[0]].concat([100]),
                        },
                    ],
                }
            )
        })

        var option = {
            tooltip: {
                trigger: 'item',
                backgroundColor: '#1540a1',
                borderColor: '#FFFFCC',
                showDelay: 0,
                hideDelay: 0,
                enterable: true,
                transitionDuration: 0,
                extraCssText: 'z-index:100',
                formatter: function (params, ticket, callback) {
                    //根据业务自己拓展要显示的内容
                    var res = ''
                    var name = params.name
                    res = "<span style='color:#fff;'>" + name
                    return res
                },
            },
            backgroundColor: '#011f4c',
            visualMap: {
                //图例值控制
                min: 0,
                max: 10000,
                show: false,
                calculable: true,
                color: ['#fff'],
                textStyle: {
                    color: '#fff',
                },
            },
            geo: {
                map: 'world',
                label: {
                    emphasis: {
                        show: false,
                    },
                },
                roam: false, //是否允许缩放
                layoutCenter: ['-15%', '115%'], //地图位置
                layoutSize: '480%',
                tooltip: {
                    textStyle: {
                        color: '#fff',
                    },
                },
                // 常规
                itemStyle: {
                    color: '#1c3067', //地图背景色
                    borderColor: '#4c81b5', //省市边界线
                    borderWidth: 0.6,
                },
                // 鼠标悬浮
                // 鼠标选中
                // 指定区域
                regions: [
                    {
                        name: '中国',
                        itemStyle: {
                            normal: {
                                color: '#294696', //地图背景色
                                borderColor: '#faff72',
                                borderWidth: 3,
                                // borderColor: '#a7b5db', //省市边界线
                                // borderWidth: 1.2,
                            },
                        },
                    },
                    {
                        name: '沙特阿拉伯',
                        itemStyle: {
                            normal: {
                                color: '#294696', //地图背景色
                                borderColor: '#faff72',
                                borderWidth: 3,
                                // borderColor: '#a7b5db', //省市边界线
                                // borderWidth: 1.2,
                            },
                        },
                    },
                    {
                        name: '阿联酋',
                        itemStyle: {
                            normal: {
                                color: '#294696', //地图背景色
                                borderColor: '#faff72',
                                borderWidth: 3,
                                // borderColor: '#a7b5db', //省市边界线
                                // borderWidth: 1.2,
                            },
                        },
                    },
                    // {
                    //     name: '阿曼',
                    //     itemStyle: {
                    //         normal: {
                    //             color: '#294696', //地图背景色
                    //             borderColor: '#faff72',
                    //             borderWidth: 3,
                    //             // borderColor: '#a7b5db', //省市边界线
                    //             // borderWidth: 1.2,
                    //         },
                    //     },
                    // },
                    {
                        name: '卡塔尔',
                        itemStyle: {
                            normal: {
                                color: '#294696', //地图背景色
                                borderColor: '#faff72',
                                borderWidth: 3,
                                // borderColor: '#a7b5db', //省市边界线
                                // borderWidth: 1.2,
                            },
                        },
                    },
                    // {
                    //     name: '科威特',
                    //     itemStyle: {
                    //         normal: {
                    //             color: '#294696', //地图背景色
                    //             borderColor: '#faff72',
                    //             borderWidth: 3,
                    //             // borderColor: '#a7b5db', //省市边界线
                    //             // borderWidth: 1.2,
                    //         },
                    //     },
                    // },
                ],
            },

            series: series,
        }

        myChart.setOption(option)
    }, [echartsRootDom])

    return <div id='WorldMap' ref={acquisitionChartRef}></div>
}

export default WorldMap
